import { useEffect, useState } from "react";

import { DELAY_BEFORE_LOADING_STATE } from "../../consts";
import SplashScreen from "./SplashScreen";

export default function SplashScreenForLoadableChunk() {
  const [showLoading, setShow] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), DELAY_BEFORE_LOADING_STATE);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return showLoading ? <SplashScreen /> : null;
}
